import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {formatDropdownData, formatQuerystring} from '../../../../../utils/formatting';
import * as locations from '../../../../../constants/locations';


import { reSortDiamonds, reSortProducts } from '../../../../../utils/product';


import * as productActionCreators from '../../../../../actions/product';
let allActionCreators = Object.assign({}, productActionCreators);

import RhinoSelect from '../../../../common/inputs/RhinoSelect';

class ResultsControls extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

		this.state = {
      genericValue: '',
    };
	}

  componentDidMount() {

  }

  componentDidUpdate(prevProps, prevState) {
    // if(window.location.host.indexOf('staging') >= 0) { 
      try {
        Load_Buttons_Hands();
      } catch(err) {
        console.error(err);
      }
    // }
  }

  getDropdownOptions() {
    switch(this.props.resultType) {
      case 'diamond':
        return this.getDiamondOptions();
      case 'setting':
        return this.getSettingOptions();
      case 'mensband':
        return this.getMensBandOptions();
      case 'womensband':
        return this.getWomensBandOptions();
      case 'fashion':
        return this.getFashionOptions();
      default:
        return this.getGenericOptions();
    }
  }

  getGenericOptions() {
    return [
      {
        display: 'Sort by',
        value: '',
      },
      {
        display: 'Price (Low to High)',
        value: 'sell_price',
      },
      {
        display: 'Price (High to Low)',
        value: '-sell_price',
      },
      {
        display: 'Total Carat Weight (Low to High)',
        value: 'ttw_dia',
      },
      {
        display: 'Total Carat Weight (High to Low)',
        value: '-ttw_dia',
      },
    ];
  }

  getDiamondOptions() {
    return [
      {
        display: 'Sort by',
        value: '',
      },
      {
        display: 'Carat (Low to High)',
        value: 'carat',
      },
      {
        display: 'Carat (High to Low)',
        value: '-carat',
      },
      {
        display: 'Price (Low to High)',
        value: 'price',
      },
      {
        display: 'Price (High to Low)',
        value: '-price',
      },
    ];
  }

  getSettingOptions() {
    return [
      {
        display: 'Sort by',
        value: '',
      },
      {
        display: 'Price (Low to High)',
        value: 'sell_price',
      },
      {
        display: 'Price (High to Low)',
        value: '-sell_price',
      },
      {
        display: 'Total Carat Weight (Low to High)',
        value: 'ttw_dia',
      },
      {
        display: 'Total Carat Weight (High to Low)',
        value: '-ttw_dia',
      },
    ];
  }

  getWomensBandOptions() {
    return [
      {
        display: 'Sort by',
        value: '',
      },
      {
        display: 'Price (Low to High)',
        value: 'sell_price',
      },
      {
        display: 'Price (High to Low)',
        value: '-sell_price',
      },
      {
        display: 'Total Carat Weight (Low to High)',
        value: 'ttw_dia',
      },
      {
        display: 'Total Carat Weight (High to Low)',
        value: '-ttw_dia',
      },
    ];
  }

  getMensBandOptions() {
    return [
      {
        display: 'Sort by',
        value: '',
      },
      {
        display: 'Price (Low to High)',
        value: 'sell_price',
      },
      {
        display: 'Price (High to Low)',
        value: '-sell_price',
      },
    ];
  }

  getFashionOptions() {
    return [
      {
        display: 'Sort by',
        value: '',
      },
      {
        display: 'Price (Low to High)',
        value: 'sell_price',
      },
      {
        display: 'Price (High to Low)',
        value: '-sell_price',
      },
      {
        display: 'Total Carat Weight (Low to High)',
        value: 'ttw_dia',
      },
      {
        display: 'Total Carat Weight (High to Low)',
        value: '-ttw_dia',
      },
    ];
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  changeSortDropdown(evt) {
    if(this.getCurrentSort() != evt.target.value) {
      this.updateData(evt.target.value);
    }
  }

  getResultCount() {
    if(this.props.resultCount === 0) {
      return 0;
    }
    if(this.props.resultCount) {
      return parseInt(this.props.resultCount);
    }
    return null;
  }

  getCurrentSort() {
    if(this.props.resultType == 'generic') {
      return this.state.genericValue;
    } else if(this.props.resultType == 'diamond') {
      if(this.props.product.diamondFilters && this.props.product.diamondFilters.sort) {
        return this.props.product.diamondFilters.sort;
      }
    } else {
      if(this.props.product.productFilters && this.props.product.productFilters.sort) {
        return this.props.product.productFilters.sort;
      }
    }
    return '';
  }

  updateData(sortVal) {
    if(this.props.resultType == 'generic') {
      this.setState({ genericValue: sortVal });
      return this.updateGenericData(sortVal);
    }
    return this.props.resultType == 'diamond' ? this.updateDiamondData(sortVal) : this.updateProductData(sortVal);
  }

  updateGenericData(sortVal) {
    this.props.updateMethod(sortVal);
    return null;
  }

  updateDiamondData(sortVal) {
    this.props.productSaveDiamondQueryFilters({'sort': sortVal});
    setTimeout(() => {
      this.props.productFetchDiamonds(formatQuerystring(this.props.product.diamondFilters))
      .then((respData) => {
        const filteredResults = reSortDiamonds(respData.results, this.props.product.diamondFilters);
        this.props.productSaveDiamondResults(filteredResults, respData.count < 100 ? filteredResults.length : respData.count);
      });
    }, 150);
  }

  updateProductData(sortVal) {
    this.props.productSaveProductQueryFilters({'sort': sortVal}, this.props.resultType);
    setTimeout(() => {
      this.props.productFetchProducts(formatQuerystring(this.props.product.productFilters))
      .then((respData) => {

        const filtersSnapshot = Object.assign({}, this.props.product.productFilters);
        const filteredResults = reSortProducts(respData.success.products, filtersSnapshot);
        
        this.props.productSaveResults(filteredResults, respData.success.count);
      });
    }, 150);
  }

	render() {

    // if(window.location.host.indexOf('staging') >= 0) { 
      try {
        Load_Buttons_Hands();
      } catch(err) {
        console.error(err);
      }
    // }
    
		return <div className='ResultsControls'>
      <div className='countWrapper'>
        {this.getResultCount() !== null ?
          <div className='countCopy'>{this.getResultCount()} {this.getResultCount() === 1 ? 'result' : 'results'}</div> :
          null
        }
      </div>
      {this.props.openFilters ?
        <div className='editWrapper'>
          <div className={'editButton'} onClick={::this.props.openFilters}><div>Filters</div></div>
        </div> :
        null
      }
      <div className='sortWrapper'>
        <RhinoSelect
          options={this.getDropdownOptions()}
          value={this.getCurrentSort()}
          changeMethod={::this.changeSortDropdown}
          rootClass='sortSelect' />
      </div>
		</div>;
	}
}
export default ResultsControls;

function mapStateToProps(state) {
  return {
    product: state.product,
  };
}

export const ResultsControlsContainer = connect(
  mapStateToProps,
  allActionCreators
)(ResultsControls);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/results/ResultsControls.jsx